import {ChangeDetectionStrategy, Component, Inject, Injectable} from "@angular/core";
import {MøteId, MøtetranskripsjonRessursClient, OppsummerMøtebehandlingsopptakDebugSpesifikasjon, OppsummertTranskribertMøtereferatModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatIcon} from "@angular/material/icon";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatToolbar} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {asynkArbeidPågårSignal, standardMinimumVarighetKonfig} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {SubmitButtonKomponent} from "web-ng2/delt/komponenter/skjema/submit-button/submit-button";

/**
 * Dialog som lar bruker redigere prompt og transkripsjon brukt for å generere protokoll fra lydopptakene av et møte
 * Bør fjernes på sikt
 */
@Component({
    selector: 'moeteprotokoll-generer-protokoll-debug-dialog',
    templateUrl: 'møteprotokoll-generer-protokoll-debug-dialog.html',
    styleUrl: 'møteprotokoll-generer-protokoll-debug-dialog.scss',
    host: {'data-testid': 'møteprotokoll-generer-protokoll-debug-dialog'},
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatInput,
        MatLabel,
        MatProgressBar,
        MatToolbar,
        ReactiveFormsModule,
        SubmitButtonKomponent,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollGenererProtokollDebugDialogKomponent {

    static vis(dialog: MatDialog, møteId: MøteId) {
        return dialog.open<MøteprotokollGenererProtokollDebugDialogKomponent, DialogParametre, MøteprotokollGenererProtokollDebugDialogRespons>(MøteprotokollGenererProtokollDebugDialogKomponent,
          {
              data: {møteId} as DialogParametre,
              disableClose: true,
              ariaLabelledBy: 'møteprotokoll-generer-protokoll-debug-dialog-tittel',
              width: '90vw',
              maxWidth: 1200
          });
    }

    laster = asynkArbeidPågårSignal();
    genererer = asynkArbeidPågårSignal(standardMinimumVarighetKonfig());

    skjema = new FormGroup({
        prompt: new FormControl<string>('', {nonNullable: true}),
        transkripsjon: new FormControl<string>('', {nonNullable: true})
    });

    private readonly møteId: MøteId;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private dialogRef: MatDialogRef<MøteprotokollGenererProtokollDebugDialogKomponent, MøteprotokollGenererProtokollDebugDialogRespons>,
                private møtetranskripsjonRessurs: MøtetranskripsjonRessursClient) {
        this.møteId = parametre.møteId;
        this.lastPromptOgTranskripsjon();
    }

    async genererProtokoll() {
        const referat = await this.genererer.utfør(() => this.møtetranskripsjonRessurs.oppsummerOpptakDebug(this.møteId, this.somSpesifikasjon()).somPromise());
        this.dialogRef.close(referat);
    }

    avbryt() {
        this.dialogRef.close(null);
    }

    //private hjelpemetoder

    private async lastPromptOgTranskripsjon() {
        const {prompt, transkripsjon} = await this.laster.utfør(() => this.møtetranskripsjonRessurs.opptakTranskripsjonerOgPrompt(this.møteId).somPromise());
        this.skjema.setValue({prompt: prompt ?? '', transkripsjon: transkripsjon ?? ''});
    }

    private somSpesifikasjon(): OppsummerMøtebehandlingsopptakDebugSpesifikasjon {
        return this.skjema.getRawValue();
    }
}

/** Generert møtereferat, eller null dersom bruker avbrøt */
export type MøteprotokollGenererProtokollDebugDialogRespons = OppsummertTranskribertMøtereferatModell | null;

export type DialogParametre = { møteId: MøteId; };

